import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import {TemplateGeneratorService} from '@app/services/template-generator.service';

@Component({
  selector: 'app-template-generator-component',
  templateUrl: './template-generator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet]
})
export class TemplateGeneratorComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private templateGeneratorService = inject(TemplateGeneratorService);


  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.templateGeneratorService.setCampaign(params.campaignId);
    });
  }
}
